// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"f877138e220bab07d67b","655":"5ac73fb4fe69c1be55b8"}[chunkId] + ".js";
};